import { ReelWinPosition } from '@cgs/data-access';
import { WinPositionDto } from '../../models';

export function winPositionMapper(responsePositions: WinPositionDto[]): ReelWinPosition[] {
  return responsePositions.map((item) => {
    const winPosition = new ReelWinPosition();
    winPosition.positions = item.positions || [];
    winPosition.symbolId = item.symbol || null;
    winPosition.win = item.win || 0;
    winPosition.winDouble = item.winDouble || 0;
    winPosition.multiplier = item.multiplier || 1;
    winPosition.type = item.type || '';
    return winPosition;
  });
}
